import styled from 'styled-components';
import {transition} from 'helpers/css';

export const Wrapper = styled.div`
  padding: 20px;
  
  grid-template-columns: repeat(2, 1fr);
  grid-auto-flow: column;
  display: grid;
`;

export const WordWrapper = styled.div`
  padding: 8px;
  border-top: 1px solid ${({theme}) => theme.variables.borderColor};
  border-bottom: 1px solid ${({theme}) => theme.variables.borderColor};
  margin-bottom: 8px;
`;

export const Group = styled.div`
  &:first-child > ${WordWrapper} {
    border-radius: 5px 0 0 5px;
    border-left: 1px solid ${({theme}) => theme.variables.borderColor};
  }

  &:last-child > ${WordWrapper} {
    border-radius: 0 5px 5px 0;
    border-right: 1px solid ${({theme}) => theme.variables.borderColor};
  }
`;

export const WordInner = styled.span`
  display: block;
  ${transition()};
  border: 1px solid transparent;
  background: ${({theme}) => `
    ${theme.variables.backgroundColor};
  `};
  border-radius: 5px;
  box-sizing: border-box;
  padding: 13px 14px;
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  
  &:hover,
  &:active {
    border-color: ${({theme}) => theme.colors.primary};
  }
`;
